var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6703 9.83254L9.49529 11.0075C8.84529 11.6575 8.84529 12.7159 9.49529 13.3659C10.1453 14.0159 11.2036 14.0159 11.8536 13.3659L13.7037 11.5159C15.0037 10.2159 15.0037 8.10755 13.7037 6.79922C12.4037 5.49922 10.2953 5.49922 8.98696 6.79922L6.97031 8.81587C5.85365 9.93254 5.85365 11.7409 6.97031 12.8575",
    stroke: "#514F55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9974 18.3346H12.9974C17.1641 18.3346 18.8307 16.668 18.8307 12.5013V7.5013C18.8307 3.33464 17.1641 1.66797 12.9974 1.66797H7.9974C3.83073 1.66797 2.16406 3.33464 2.16406 7.5013V12.5013C2.16406 16.668 3.83073 18.3346 7.9974 18.3346Z",
    stroke: "#514F55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachSquare);
export default __webpack_public_path__ + "static/media/attachSquare.ce58171373d16520bc097188a082bc6f.svg";
export { ForwardRef as ReactComponent };